import { render } from "./DocumentReportAutovalidation.vue?vue&type=template&id=41ffe56a&scoped=true&ts=true"
import script from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"
export * from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"

import "./DocumentReportAutovalidation.vue?vue&type=style&index=0&id=41ffe56a&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ffe56a"]])

export default __exports__